import { SimpleAdUnit } from "@/components/AdUnit";
import { getVersionAssetsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import { getPriceType } from "../../../functions/getPriceType";
import {
  MetaRatingsPlayer,
  generateNavigationUrl,
} from "../../../redux/players/playersSlice";
import { PlayersCardView } from "../Players/MrDbListCardView/PlayersCardView";

type Props = {
  players: MetaRatingsPlayer[];
  show3Chem: boolean;
  playerRoleId?: number;
};

export const PlayerList = ({ players, show3Chem, playerRoleId }: Props) => {
  const versionAssets = useSelector(getVersionAssetsSelector);
  const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
  useEffect(() => {
    const raw = sessionStorage.getItem("playerListScroll");
    if (raw) {
      window.scrollTo(0, Number(raw));
      sessionStorage.removeItem("playerListScroll");
    }
  }, []);

  return (
    <>
      {players.map((p, index) => {
        const versionName = versionAssets[p.versionId]?.name || "";
        const navLink = generateNavigationUrl({
          playerRoleId: playerRoleId ?? p.playerRoleId,
          resourceId: p.resourceId,
          name: p.name,
          versionName,
          evolutionPath: p.evolutionPath,
          evoPathId: p.evoPathId,
          canEvolve: p.canEvolve,
        });
        return (
          <Fragment key={navLink + index}>
            {index % 8 === 0 && index > 0 && <SimpleAdUnit />}
            <NavLink
              to={navLink}
              onClick={() => {
                sessionStorage.setItem(
                  "playerListScroll",
                  String(window.scrollY),
                );
              }}
              state={{
                p,
                chemistryContext: show3Chem ? 3 : 0,
              }}
            >
              <PlayersCardView
                key={p.resourceId}
                assetId={p.resourceId}
                chemistry={show3Chem ? 3 : 0}
                {...p}
                priceType={getPriceType(
                  p.price,
                  p.sbcPrice,
                  p.isSbcPlayer,
                  p.isObjectivePlayer,
                )}
                desktopCardUrl={`${assetsBaseUrl}/fc25/playercards/square/${p.resourceId}.png`}
                mobileCardUrl={`${assetsBaseUrl}/fc25/playercards/small/${p.resourceId}.png`}
                metaRating={p.metaRating}
                playerRoleId={playerRoleId ?? p.playerRoleId}
                price={p.price || p.sbcPrice || 0}
                untradeable={p.untradeable}
              />
            </NavLink>
          </Fragment>
        );
      })}
    </>
  );
};
